( function() {
  const STORAGE_KEY = 'source_value';
  const COOKIE_NAME = 'referrer';
  const COOKIE_DAYS = 1;

  const UTM_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_domain',
  ];

  const CLICK_IDS = [
    { key: 'gclid', label: 'Google Adwords' },
    { key: 'gbraid', label: 'Google Adwords' },
    { key: 'wbraid', label: 'Google Adwords' },
    { key: 'msclkid', label: 'Microsoft Ads' },
    { key: 'fbclid', label: 'Facebook' },
  ];

  // https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
  function getParameterByName( name, url ) {
    if ( !url ) url = window.location.href;

    /* eslint-disable */
      name = name.replace( /[\[\]]/g, '\\$&' );
    /* eslint-enable */

    const regex = new RegExp( '[?&]' + name + '(=([^&#]*)|&|#|$)' );
    const results = regex.exec( url );
    if ( !results ) {
      return null;
    }
    if ( !results[2] ) {
      return '';
    }
    return decodeURIComponent( results[2].replace( /\+/g, ' ' ) );
  }

  function getStored() {
    try {
      return sessionStorage.getItem( STORAGE_KEY );
    } catch ( e ) {
      return null;
    }
  }

  function setStored( value ) {
    try {
      sessionStorage.setItem( STORAGE_KEY, value );
    } catch ( e ) {
      return;
    }
  }

  function getCookie( name ) {
    const match = document.cookie.match(
      new RegExp( '(?:^|;\\s*)' + name + '=([^;]*)' )
    );
    return match ? decodeURIComponent( match[1] ) : null;
  }

  function setCookie( name, value, days ) {
    let expires = '';
    if ( days ) {
      const date = new Date();
      date.setTime( date.getTime() + ( days*24*60*60*1000 ) );
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent( value || '' ) + expires + '; path=/; SameSite=Lax';
  }

  function hostOf( url ) {
    return url.replace( /^(?:https?:\/\/)?(?:www\.)?/i, '' ).split( '/' )[0];
  }

  function sourceFromUrl() {
    const parts = [];

    UTM_KEYS.forEach( function( key ) {
      const value = getParameterByName( key );
      if ( value ) {
        parts.push( key + '=' + value );
      }
    } );

    let click = null;
    for ( let i = 0; i < CLICK_IDS.length; i++ ) {
      const value = getParameterByName( CLICK_IDS[i].key );
      if ( value ) {
        click = { key: CLICK_IDS[i].key, label: CLICK_IDS[i].label, value: value };
        break;
      }
    }

    if ( parts.length > 0 ) {
      if ( click ) {
        parts.push( click.key + '=' + click.value );
      }
      return parts.join( '&' );
    }

    if ( click ) {
      return click.label + ': ' + click.key + '=' + click.value;
    }

    return '';
  }

  function sourceFromReferrer() {
    if ( !document.referrer ) {
      return 'direct';
    }

    const referrer = hostOf( document.referrer );
    if ( !referrer || referrer === hostOf( location.host ) ) {
      return 'direct';
    }

    return referrer;
  }

  function checkForSource() {
    let stored = getStored();
    if ( !stored ) {
      stored = getCookie( COOKIE_NAME );
      if ( stored ) {
        setStored( stored );
      }
    }

    const urlSource = sourceFromUrl();
    if ( urlSource ) {
      setStored( urlSource );
    } else if ( !stored ) {
      setStored( sourceFromReferrer() );
    }

    setCookie( COOKIE_NAME, getStored(), COOKIE_DAYS );
  }

  function applyValue( input, sourceValue ) {
    input.value = sourceValue;
    input.setAttribute( 'value', sourceValue );
  }

  function updateSourceInput() {
    const sourceValue = getStored();
    if ( !sourceValue ) {
      return;
    }

    document.querySelectorAll( '.gfsi_source' ).forEach( function( input ) {
      applyValue( input, sourceValue );
    } );

    document.querySelectorAll( 'template' ).forEach( function( template ) {
      if ( !template.content ) {
        return;
      }
      template.content.querySelectorAll( '.gfsi_source' ).forEach( function( input ) {
        applyValue( input, sourceValue );
      } );
    } );
  }

  document.addEventListener( 'gform_post_render', updateSourceInput );
  document.addEventListener( 'gform_page_loaded', updateSourceInput );

  if ( window.jQuery ) {
    jQuery( document ).on( 'gform_post_render', updateSourceInput );
  }

  checkForSource();
  updateSourceInput();
} )();
